<mat-card class="p-0 pt-2 imageAttachContainer">

  <mat-card-header class="send-file" style="min-height: 100px">
    <div class="imageAttachContainer__fileArea m-0 w-100" [uploadInputFor]="This">
        <input multiple (change)="onFileSelected($event)" type="file" id="file">
      <div class="d-flex align-items-center justify-content-center w-100 h-100" style="color: #6d6d6d; font-size: 16px; position: absolute; left: 0; top: 0">
        Or drag picture(s) here ...
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="row w-100 p-2" *ngIf="images.length > 0" [uploadInputFor]="This">
      <div class="col-md-12 col-sm-12" cdkDropList (cdkDropListEntered)="entered($event)" (cdkDropListDropped)="drop($event)">
        <mat-card cdkDrag (mouseover)="overAction(i)" (cdkDragStarted)="cdkDragStarted($event, childItem, i)"
                  (cdkDragReleased)="cdkDragReleased($event, i)" *ngFor="let img of images; let i = index"
                  style="width: 180px;float: left;margin: 5px; background-color: #f8f8f8;"
                  (click)="selectedImage = img" [ngClass]="{ selected: selectedImage == img }" class="mat-uploaded-image">

          <mat-card-content style="background-color: #000; position: relative;">
            <div mat-card-image class="mat-card-base mt-1" [style.backgroundImage]="'url(' + img.imageUrl + '/150x150)'"></div>
            <button style="    position: absolute;
    top: -10px;
    right: -5px" mat-mini-fab color="glb_pinkbtn" (click)="deleteImage(img)" class="del-img-icon">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-card-content>
</mat-card>
